import { Icon, Logo, SkeletonLoader } from '@kanda-libs/ks-design-library';
import useEnquiryHeader from './useEnquiryHeader';

const EnquiryHeader: React.FunctionComponent = function () {
  const { logoContent, hasLogo, isLoading } = useEnquiryHeader();
  return (
    <div className="flex w-full flex-row-reverse justify-end">
      <Logo className="my-auto hidden md:block" />
      <Logo className="my-auto block md:hidden" compact />
      {hasLogo && (
        <>
          <div className="px-2 md:px-4 my-auto h-4">
            <Icon icon="close" size={16} isLoading={isLoading} />
          </div>
          <div className="max-h-[44px] max-w-24 flex">
            <SkeletonLoader
              width={56}
              height={28}
              isLoading={isLoading}
              afterLoading={
                <img
                  src={logoContent}
                  alt="Partner"
                  className="max-h-[44px] my-auto"
                />
              }
            />
          </div>
        </>
      )}
    </div>
  );
};

export default EnquiryHeader;
